import React from "react";
import {
  Dates,
  Header, HeaderLeft,
  HeaderWrapper,
  Title, TitleWithoutDates,
  Wrapper,
} from "./сhapter.styles";
import ChapterContent from "./content";
import ChapterButtons from "./btns";
import { useChapterDisplayDataContext } from "contexts/ChapterDisplayContext";
import { formatedDate } from "utils";
import { ChapterEditorDataProvider } from "contexts/ChapterEditorContext";
import Editor from "../../editor/Editor";
import { useTranslation } from "react-i18next";
import { EyeInvisibleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export default function Chapter() {
  const { t } = useTranslation();
  const {
    chapter,
    setIsCollapsed,
    isEditorOpen,
    setIsEditorOpen,
    initialDraft
  } = useChapterDisplayDataContext();

  const fromDate = formatedDate(chapter.date_from_year, chapter.date_from_month, chapter.date_from_day);
  const toDate = formatedDate(chapter.date_to_year, chapter.date_to_month, chapter.date_to_day)

  return (
    <Wrapper>
      <HeaderWrapper onClick={() => setIsCollapsed((p) => !p)}>
        <Header>
          <HeaderLeft>
            {!fromDate && !toDate && <TitleWithoutDates>{chapter.title}</TitleWithoutDates>}
            <Dates>
              {fromDate}
              {fromDate && toDate && " - "}
              {toDate}
            </Dates>
            {chapter.is_hidden && (
              <Tooltip title={t("wall.hiddenTooltip")}>
                <EyeInvisibleOutlined />
              </Tooltip>
            )}
          </HeaderLeft>

          <ChapterButtons />
        </Header>
        {(fromDate || toDate) && <Title>{chapter.title}</Title>}
      </HeaderWrapper>

      <ChapterContent />

      {isEditorOpen && (
        <ChapterEditorDataProvider storyId={chapter.story} initialDraft={initialDraft}>
          <Editor isOpen={isEditorOpen} onClose={() => setIsEditorOpen(false)} />
        </ChapterEditorDataProvider>
      )}
    </Wrapper>
  );
}
